// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1u1_x","calendarButtons":"ClockData_calendarButtons__39O-V"};